import { handleCompanySelection } from './companyManager';
import type { User, ProcessedUser } from '@/types';

/**
 * Kullanıcı verilerini işleyerek gerekli aksiyonları alır
 */
export const processUser = (
  userData: User,
  showCompanySelectionModal: () => void
): ProcessedUser | null => {
  try {
    // Company ID belirleme
    const companyId = handleCompanySelection(userData, showCompanySelectionModal);


    return {
      id: userData.id,
      firstName: userData.firstName,
      lastName: userData.lastName,
      email: userData.email,
      roles: userData.roles,
      companyId: companyId,
      organization: userData.organization,
      userTitle: userData.userTitle
    };

  } catch (error) {
    console.error('Error processing user:', error);
    return null;
  }
};